site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length === 0) return;

		$(window).load(function () {
			site.maxHeight.setHeight(selector);
		});
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};

site.dropdownMenu = {
	init: function () {
		site.maxHeight.init('#submenu ul ul');
		$('> a', '#submenu .level2.children').on('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $this = $(this);
			if ($this.hasClass('open')) {
				site.dropdownMenu.close(true);
			}
			else {
				site.dropdownMenu.open($this);
			}

			$('body.sub-open').on('click touchstart', function (e) {
				site.dropdownMenu.close(true);
			});
		});
	},
	open: function (open) {
		site.dropdownMenu.close(true);
		var $body = $('body');
		var $this = open;
		$body.toggleClass('sub-open');
		$this.toggleClass('open').next('ul.menu').toggleClass('open').parent('.children').toggleClass('open');
	},
	close: function (closing) {
		closing = closing || false;
		var $body = $('body');

		$body.removeClass('sub-open');
		$('#submenu').find('.open').addClass('closing').removeClass('open');

		if (closing) {
			$body.addClass('sub-closing');
			setTimeout(function () {
				$('body').removeClass('sub-closing');
				$('#submenu').find('.closing').removeClass('closing');
			}, 400);
		}
	}
};

site.inits.push('site.dropdownMenu.init()');
